import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import * as authUserSelectors from '../../../../redux/auth/user/selectors';

import { showUpdateSubscriptionModal } from '../../../../redux/ui/actions';

import UpdateSubscriptionButton from './UpdateSubscriptionButton';

const UpdateSubscriptionButtonConnected = (props) => <UpdateSubscriptionButton {...props} />;

const mapStateToProps = (state) => ({
  isUserStandard: authUserSelectors.selectIsUserStandard(state),
  isUserAdvanced: authUserSelectors.selectIsUserAdvanced(state),
});

const mapActionsToProps = {
  push,
  showUpdateSubscriptionModal,
};

export default connect(mapStateToProps, mapActionsToProps)(UpdateSubscriptionButtonConnected);
